import React from "react";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";

import { brandedQrProps, useZoniqQrLogoBadge, type BrandedQrTheme } from "../../utils/brandedQr";

type Props = {
  id: string;
  value: string;
  variant: "svg" | "canvas";
  theme?: BrandedQrTheme;
  size?: number;
};

export const BrandedQrCode: React.FC<Props> = ({ id, value, variant, theme = "dark", size }) => {
  const badge = useZoniqQrLogoBadge(theme, size);
  const props = brandedQrProps(id, value, badge, theme, size);

  if (variant === "canvas") {
    return <QRCodeCanvas {...props} />;
  }

  return <QRCodeSVG {...props} />;
};
